module.exports = __webpack_public_path__ + "static/media/115.eeef7c60.jpg";